import React from 'react';
import { Text } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { createStackNavigator } from '@react-navigation/stack';
import { NavigationContainer } from '@react-navigation/native';
import LoginScreen from './screens/LoginScreen';
import HomeScreen from './screens/HomeScreen';
import DeviceScreen from './screens/DeviceScreen';
import { AuthProvider } from './config/AuthContext'; // Importe o AuthProvider

const Stack = createStackNavigator();

const App = () => {
  return (
    <NavigationContainer>
      <AuthProvider>
        <Stack.Navigator>
          <Stack.Screen
            name="Login"
            component={LoginScreen}
            options={{ headerShown: false }}
          />
          <Stack.Screen
            name="HomeScreen"
            component={HomeScreen}
            style={{}}
            options={{
              title: 'Marrari Pro-X',
              headerStyle: {
                backgroundColor: '#41403F'
              },
              headerTintColor: '#E0DFDC',
              headerTitleStyle: {
                fontWeight: 'bold',
                fontSize: 24,
              }
              // Other options
            }}
          />
          <Stack.Screen
            name="DeviceScreen"
            component={DeviceScreen}
            //Armazena e exibe o dispositivo no Header da tela
            options={
              ({ route }) => ({
              headerTitle: route.params.deviceName,
              headerStyle: {
                backgroundColor: '#41403F'
              },
              headerTintColor: '#E0DFDC',
              headerTitleStyle: {
                fontWeight: 'bold',
                fontSize: 24,
              }
            })}
          />
        </Stack.Navigator>
      </AuthProvider>
    </NavigationContainer>
  );
};

export default App;
